/*jshint esversion: 6 */

export const setWinnerForQuiz = (data) => ({
    type: 'winner_for_quiz',
    quiz: data
});
